import { AutoPricingStatuses as Statuses } from '@wkda/autopricing-service';
const warnAboutMissingLogger = () => console.warn('`whatsapp module` is missing `logger` dependency');
export function createWhatsapp(_ref) {
  let {
    whatsappService,
    logger,
    apmLogger
  } = _ref;
  function isValidStatus(status) {
    return Object.values(Statuses).includes(status);
  }
  const checkStatus = status => {
    if (!isValidStatus(status)) {
      throw new Error("Unknown whatsapp status: " + status + ". Valid values are: " + Object.values(Statuses));
    }
    return status === 'success';
  };
  function subscribe(_ref2) {
    let {
      carleadHash,
      onMessageHandler,
      onErrorHandler,
      resubscribeIntervalInSec = 250
    } = _ref2;
    let intervalID;
    let stopListen = () => {};
    const onMessage = data => {
      checkStatus(data.status);
      onMessageHandler(carleadHash, data, whatsappService);
    };
    const onError = err => {
      apmLogger.error(err);
      if (logger !== null && logger !== void 0 && logger.info) {
        logger.info({
          message: '[WHATSAPP] Subscription error'
        });
      } else {
        console.error(err);
        warnAboutMissingLogger();
      }
      onErrorHandler(err, carleadHash);
    };
    const unsubscribe = () => {
      clearInterval(intervalID);
      stopListen();
      whatsappService.closeConnection();
    };
    try {
      whatsappService.init(carleadHash);
      stopListen = whatsappService.listen(onMessage, onError);
      intervalID = window.setInterval(() => {
        if (whatsappService.isInitialized) {
          stopListen();
          whatsappService.closeConnection();
          whatsappService.init(carleadHash);
          stopListen = whatsappService.listen(onMessage, onError);
        }
      }, resubscribeIntervalInSec * 1000);
    } catch (err) {
      onError(err);
    }
    return unsubscribe;
  }
  return {
    subscribe
  };
}